import { Component, Input, OnInit } from '@angular/core';
import { OverrideNoteDetail } from 'src/app/public/app/models/overrideNoteDetail';

@Component({
  selector: 'app-upload-resumes-actions-modal',
  templateUrl: './upload-resumes-actions-modal.component.html'
})
export class UploadResumesActionsModalComponent implements OnInit {

  @Input() modalInstance: any;
  @Input() resolve: any;

  candidateId: any;
  candidateName: any;
  suspendedMonths: any;
  releaseDate: any;
  allowOverride: any;
  releasedJobDetails: any;
  type: any;
  modalTitle: string;
  recruiterDetails: any;
  callbackObject: any;

  ngOnInit() {
    this.candidateId = this.resolve.candidateId;
    this.candidateName = this.resolve.candidateName;
    this.suspendedMonths = this.resolve.suspendedMonths;
    this.releaseDate = this.resolve.releaseDate;
    this.allowOverride = this.resolve.allowOverride;
    this.releasedJobDetails = this.resolve.releasedJobDetails;
    this.type = this.resolve.type;
    this.modalTitle = 'Override';
    this.recruiterDetails = new OverrideNoteDetail(this.candidateId);

    this.callbackObject = { callbackType: 'cancel', entity: {} };
  }

  saveCallback() {
    this.callbackObject.callbackType = 'save';
    this.callbackObject.entity = this.recruiterDetails;
    this.closeModal();
  }

  closeModal() {
    this.modalInstance.close(this.callbackObject);
  }

  dismissModal() {
    this.modalInstance.dismiss('cancel');
  }
}
